export const actionConverterMiddleware = () => (next) => (action) => {
    const { type } = action;

    if (typeof type !== 'undefined' && typeof type !== 'string') {
        action.type = type.toString();
    }

    return next(action);
};
